module.exports = __webpack_public_path__ + "static/media/uiux.2fd1ff50.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Coinbase/uiux.mp4
// module id = 1056
// module chunks = 0